import React from "react";
import { Box } from "@mui/material";

interface Props {
  first?: boolean;
  last?: boolean;
  onlyOne?: boolean;
}

export const FormItemConnector = ({
  first,
  last,
  onlyOne,
}: Props): JSX.Element => {
  return (
    <Box
      id="FormItemConnector"
      sx={{
        display: {
          sm: "flex",
          xs: "none",
        },
        flexDirection: "column",
        alignItems: "center",
        width: 100,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          backgroundColor: first ? "none" : "#F4F5FF",
          width: 2,
        }}
      >
        {""}
      </Box>
      <Box
        sx={{
          border: "solid 4px #F4F5FF",
          borderRadius: 4,
          width: 20,
          height: 20,
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          backgroundColor: last || onlyOne ? "none" : "#F4F5FF",
          width: 2,
        }}
      >
        {""}
      </Box>
    </Box>
  );
};
